import common_de from "./de/common_de.json";

const resources = {
  de: {
    common: common_de,
  },
};

export default resources;
